module.exports = __webpack_public_path__ + "img/FOAMING.6a8c7616.jpg";